












import { Component, Prop, Vue } from 'vue-property-decorator';
import DocButton from '@/components/ui/buttons/DocButton.vue';

@Component({
  components: {
    DocButton,
  },
})
export default class Header extends Vue {
  @Prop(String) theme: string;

  sendGtmLogin() {
    this.$sendGtmEvent({
      event: 'vox_docs_to_login',
      category: 'main_docs',
      action: 'login',
      label: this.$router.currentRoute.fullPath,
    });
  }

  sendGtmSignup() {
    this.$sendGtmEvent({
      event: 'vox_docs_to_signup',
      category: 'main_docs',
      action: 'signup',
      label: this.$router.currentRoute.fullPath,
    });
  }
}
